import type {
  Cryptocurrency,
  SupportedCurrency,
} from '__generated__/globalTypes';
import { Currency } from '__generated__/globalTypes';

import { isCryptocurrency } from './cryptocurrency';

export const getCurrenciesFromSettlementCurrencies = (
  settlementCurrencies: SupportedCurrency[]
) =>
  settlementCurrencies.reduce<Currency[]>((acc, curr) => {
    if (isCryptocurrency(curr)) return [...acc, Currency.ETH];
    if (!acc.includes(Currency.FIAT)) return [...acc, Currency.FIAT];
    return acc;
  }, []);

export const getCurrenciesFromSettlementCurrenciesWhenCannotSwapCrypto = (
  settlementCurrencies: SupportedCurrency[],
  cryptocurrency: Cryptocurrency
) =>
  settlementCurrencies.reduce<Currency[]>((acc, curr) => {
    if (curr === cryptocurrency) return [...acc, Currency.ETH];
    if (!acc.includes(Currency.FIAT)) return [...acc, Currency.FIAT];
    return acc;
  }, []);
